<ngx-json-ld [json]="schema"></ngx-json-ld>
<app-header #header></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>
<div class="container">
  <div class="section s1">
    <div class="section-content">
      <div class="w50"><img class="s1-img" [src]="'./assets/images/itunes_movie_deals_img_' + getLangForHeroImage() + '.jpg'" alt="itunes movie deals"></div>
      <div class="w50">
        <h1><img class="apple-icon" src="./assets/images/store-icons/apple-tv.png" alt="Apple TV">{{getString('itunesMovieDeals')}}</h1>
        <b>{{getString('itunesMovieDealsS1Subtitle')}}</b>
        <p>{{getString('itunesMovieDealsS1Text')}}</p>
        <div class="txt-algn-cntr"><a [routerLink]="'/' + getCountry() + '/itunes/' + getString('moviesUrl') + '/' + getString('onSaleUrl')"><button type="button" class="big-btn blue-button">{{getString('seeTheOffers')}}</button></a></div>
      </div>
    </div>
  </div>
  <div class="section s2">
    <div class="section-content">
      <div class="w60">
        <h2>{{getString('itunesMovieDealsS2Title')}}</h2>
        <p>{{getString('itunesMovieDealsS2Text')}}</p>
      </div>
      <div class="w40 txt-algn-cntr">
        <div class="gray-title">{{getString('todaysTopseller')}}</div>
        <app-single-carousel *ngIf="items" [items]="items" [title]="'itunes'" (onWishlistClick)="wishListClicked($event)"></app-single-carousel>
        <div class="txt-algn-cntr"><a [routerLink]="'/' + getCountry() + '/itunes/' + getString('moviesUrl') + '/' + getString('onSaleUrl')"><button type="button" class="big-btn blue-button">{{getString('moreTopDeals')}}</button></a></div>
      </div>
    </div>
  </div>
  <div class="section s3">
    <div class="section-content">
        <div class="w40 txt-algn-cntr">
          <div class="gray-title">{{getString('userReviews')}}</div>
          <app-single-review></app-single-review>
        </div>
        <div class="w60">
      <h2>{{getString('itunesMovieDealsS3Title')}}</h2>
      <p>{{getString('itunesMovieDealsS3Text')}}</p>
        </div>
    </div>
  </div>
  <div class="section s4">
    <div class="section-content">
        <div class="w60">
          <h2>{{getString('itunesMovieDealsS4Title')}}</h2>
          <p>{{getString('itunesMovieDealsS4Text')}}</p>
          <div class="txt-algn-cntr"><a [routerLink]="'/' + getCountry() + '/' + getString('wishlistUrl')"><button type="button" class="big-btn blue-button">{{getString('addMoviesToWishList')}}</button></a></div>
        </div>
        <div class="w40 txt-algn-cntr">
          <span class="gray-title">{{getString('cheapChartsSmartWishList')}}</span>
          <img class="s4-img" src="./assets/images/wishlist_bell_piggy.png" alt="itunes wishlist">
          <div class="s4-steps">
            <div>{{getString('itunesMovieDealsS4Step1')}}</div>
            <div>{{getString('itunesMovieDealsS4Step2')}}</div>
            <div class="blue-text">{{getString('itunesMovieDealsS4Step3')}}</div>
          </div>
        </div>
    </div>
  </div>
  <div class="section">
    <div class="section-content">
      <div class="w50 txt-algn-cntr">
        <span class="gray-title">{{getString('appleTVMovieDeals')}}</span>
        <img class="s5-img" src="./assets/images/remote_control.jpg" alt="apple tv deals">
      </div>
        <div class="w50">
          <h2>{{getString('itunesMovieDealsS5Title')}}</h2>
          <p>{{getString('itunesMovieDealsS5Text')}}</p>
          <div class="txt-algn-cntr"><a [routerLink]="'/' + getCountry() + '/itunes/' + getString('moviesUrl') + '/' + getString('movie4kUrl')"><button type="button" class="big-btn blue-button">{{getString('check4KDeals')}}</button></a></div>
        </div>
    </div>
  </div>
  <div class="section">
    <app-faq class="faq-section-content" [faqCategory]="'itunes-movie-deals'"></app-faq>
    <div class="page-links">
      <a [routerLink]="'/' + getCountry() + '/' + getString('itunesMovieDealsUrl')" class="blue-text">{{getString('itunesMovieDeals')}}</a> |
      <a [routerLink]="'/' + getCountry() + '/' + getString('itunesMovies4KUrl')">{{getString('itunesMovies4K')}}</a> |
      <a [routerLink]="'/' + getCountry() + '/' + getString('primeVideoDealsUrl')">{{getString('amazonMovieDeals')}}</a>
      <ng-container *ngIf="getCountry() == 'us'"> | <a [routerLink]="'/us/' + getString('vuduMovieDealsUrl')">{{getString('vuduMovieDeals')}}</a></ng-container>
    </div>
  </div>
</div>
<div>
  <app-home-footer></app-home-footer>
</div>
